import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import { shuffle } from 'lodash';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from 'components/ErrorBoundary';
import { useState } from 'react';
import CustomeDate from './customeDate';

const topTopCoveredEntities = [
  {
    ce: 1,
    label: 'PharmaForce General Hospital 1',
    count: 4000,
    saving: 155954,
  },
  { ce: 2, label: 'PharmaForce FQHC 2', count: 1000, saving: 124000 },
  { ce: 3, label: 'PharmaForce STD 3', count: 523, saving: 110000 },
  { ce: 4, label: 'PharmaForce TB 4', count: 659, saving: 98456 },
  { ce: 5, label: 'PharmaForce TB 5', count: 256, saving: 89254 },
  { ce: 6, label: 'PharmaForce CHC 5', count: 214, saving: 75412 },
  { ce: 7, label: 'PharmaForce General Hospital 2', count: 854, saving: 65123 },
  { ce: 8, label: 'PharmaForce General Hospital 3', count: 526, saving: 64145 },
  {
    ce: 9,
    label: 'PharmaForce General Hospital 4',
    count: 1456,
    saving: 62145,
  },
  {
    ce: 9,
    label: 'PharmaForce General Hospital 5',
    count: 1487,
    saving: 59997,
  },
];

const TopCoveredEntities = () => {
  const [data, setData] = useState(topTopCoveredEntities);
  const [active, setActive] = useState('12');
  const labels = data.map(({ label }) => label);
  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (item) {
            const { label, count } = data[item[0].dataIndex];
            return `${label}\nRx Count ${count}`;
          },
          label: function (d,t) {
            var xLabel = d.dataset.label;
            var yLabel ='$' + d.formattedValue;
            return xLabel + ': ' + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'end'
            : 'start';
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'black'
            : 'black';
        },
        anchor: 'end',
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          value: {
            color: '#2B3346',
          },
        },
        formatter: function (value) {
          return (
            '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          );
        },
      },
    },
    scales: {
      x: {
        display: false,
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Program Value',
        data: data.map(({ saving }) => saving),
        borderColor: 'rgba(213, 53, 31, 1)',
        backgroundColor: 'rgba(213, 53, 31, 1)',
      },
    ],
  };
  const handleActive = (title) => {
    if (title === active) return;
    setActive(title);
    const shuffledArry = shuffle(data);
    setData(shuffledArry);
  };

  const getDate = () => {
    setActive('custom')
  };

  return (
    <ErrorBoundary>
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className='f-20 font-weight-500 mb-0'>
                Top 10 Covered Entities
                <p className='dashboard-sub-text'>By Program Value</p>
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
                <NavItem>
                  <NavLink
                    className={
                      active === '3'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('3')}
                  >
                    3 Mon
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      active === '6'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('6')}
                  >
                    6 Mon
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      active === '12'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('12')}
                  >
                    1 Yr
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={
                      active === 'custom'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }>
                    <CustomeDate getDate={getDate} active={active} />
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <div className='dashboard-chart-height-BITool'>
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
          <div className='view-report'>
            <a
              href="data:text/csv;charset=utf-8,'+escape(csv)+'"
              download='filename.csv'
            >
              {' '}
              View Report{' '}
            </a>
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default TopCoveredEntities;
